import React, { useState, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { Grid, withStyles } from '@material-ui/core'
import { authorization } from '../../../../../Module/Auth/Auth'
import { PIPELINE_EMAILS_STEPS_ENUM } from './options'
import { EditSequenceProvider } from './components/Steps/EditSequence/context/EditSequenceContext'
import { CreateSequence } from './components/Steps/EditSequence/CreateSequence'
import EnrollmentsView from './components/Steps/EnrollmentsView'
import SequenceView from './components/Steps/SequenceView'
import { EditSequence } from './components/Steps/EditSequence/EditSequence'
import style from './style'
import { PATHS } from 'Config/Routing/paths'

const EmailPipelineView = ({
  classes,
  pipelineStage,
  cityId,
  cityName,
  countryName,
  cityEmail,
  countryId,
  url,
  cityTimezone,
  isOnsiteTrainingEnabled,
}) => {
  const history = useHistory()
  const [stage, setStage] = useState(pipelineStage)
  const [communicationsType, setCommunicationsType] = useState('all')
  const [sequencesType, setSequencesType] = useState('all')
  const [sequencesSource, setSequencesSource] = useState('all')
  const user = useMemo(() => authorization.getUser(), [])
  const [selectedRows, setSelectedRows] = useState({})

  const step = useMemo(() => {
    const statsOrEditSection = history.location.pathname.split('/')[7]
    const isSequenceCreateSection = history.location.pathname.includes(
      PATHS.cities.ambassadorsEmailsCreate,
    )
    return (
      statsOrEditSection ||
      (isSequenceCreateSection
        ? PIPELINE_EMAILS_STEPS_ENUM.SEQUENCE_CREATE
        : PIPELINE_EMAILS_STEPS_ENUM.SEQUENCES_VIEW)
    )
  }, [history.location.pathname])

  const handleStageChange = value => {
    setSelectedRows({})
    setStage(value)
  }

  const handleCommunicationsType = value => {
    setSelectedRows({})
    setCommunicationsType(value)
  }

  const handleSequencesType = value => {
    setSelectedRows({})
    setSequencesType(value)
  }

  const handleSequencesSource = value => {
    setSelectedRows({})
    setSequencesSource(value)
  }

  const createEmptySequence = () => ({
    Action: [],
    DateSequenceTemplate: [],
    Trigger: [],
    city: cityId,
    name: `${new Date().getTime()}`,
    id: `temp-sequence-${new Date().getTime()}`,
    stage,
    owner: `${user.firstName} ${user.lastName}`,
    hasScheduledTrigger: false,
  })

  return (
    <Grid container direction="row">
      <Grid item xs>
        <Grid container direction="column" className={classes.leftContainer}>
          <Grid>
            {step === PIPELINE_EMAILS_STEPS_ENUM.SEQUENCES_VIEW ? (
              <SequenceView
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                communicationsType={communicationsType}
                url={url}
                pipelineStage={stage}
                handleCommunicationsType={handleCommunicationsType}
                handleSequencesType={handleSequencesType}
                handleSequencesSource={handleSequencesSource}
                handlePipelineStageChange={handleStageChange}
                cityId={cityId}
                countryId={countryId}
                cityName={cityName}
                countryName={countryName}
                cityTimezone={cityTimezone}
                sequencesType={sequencesType}
                sequencesSource={sequencesSource}
                isOnsiteTrainingEnabled={isOnsiteTrainingEnabled}
              />
            ) : null}
            {step === PIPELINE_EMAILS_STEPS_ENUM.SEQUENCE_STATS ? (
              <EnrollmentsView
                url={url}
                cityId={cityId}
                cityName={cityName}
                countryName={countryName}
                pipelineStage={stage}
              />
            ) : null}
            {step === PIPELINE_EMAILS_STEPS_ENUM.SEQUENCE_EDIT ? (
              <EditSequenceProvider
                initialValues={{
                  stage: stage === 'all' ? 'approved' : stage,
                }}
              >
                <EditSequence
                  url={url}
                  cityId={cityId}
                  userEmail={user.email}
                  cityEmail={cityEmail}
                  cityTimezone={cityTimezone}
                  isOnsiteTrainingEnabled={isOnsiteTrainingEnabled}
                />
              </EditSequenceProvider>
            ) : null}
            {step === PIPELINE_EMAILS_STEPS_ENUM.SEQUENCE_CREATE ? (
              <EditSequenceProvider
                initialValues={{
                  sequence: createEmptySequence(),
                  stage: stage === 'all' ? 'approved' : stage,
                }}
              >
                <CreateSequence
                  url={url}
                  cityId={cityId}
                  cityEmail={cityEmail}
                  isOnsiteTrainingEnabled={isOnsiteTrainingEnabled}
                  pipelineStage={stage}
                  cityTimezone={cityTimezone}
                />
              </EditSequenceProvider>
            ) : null}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default withStyles(style)(EmailPipelineView)
